import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {searchTypeahead} from 'lib/search';
import styles from './input.module.scss';

import icon from './img/zoom@2x.png';

const sizes = {
  large: 'is-size-6',
  small: 'is-size-7',
};

class Input extends Component {
  state = {
    typeaheadResults: [],
    query: '',
  };

  onChange = e => {
    const {children} = this.props;
    if (!children) {
      return;
    }
    const {
      target: {value: query},
    } = e;
    searchTypeahead(query).then(typeaheadResults =>
      this.setState({typeaheadResults, query})
    );
  };

  render() {
    const {defaultValue, size, placeholder, children} = this.props;
    const {typeaheadResults, query} = this.state;

    return (
      <form
        action="/search"
        className={`${styles.Input} ${styles[`Input--${size}`]}`}
        method="GET"
      >
        <div className="field">
          <div className="control has-icons-left">
            <input
              autoComplete="off"
              className={classNames(
                'input',
                `is-${size}`,
                sizes[size],
                styles.Input__control
              )}
              defaultValue={defaultValue}
              name="query"
              onChange={this.onChange}
              placeholder={placeholder}
              type="text"
            />
            <span
              className={classNames(
                'icon is-small is-left',
                styles.Input__icon
              )}
            >
              <img className={styles.Input__icon__img} src={icon} />
            </span>
          </div>
        </div>
        {children && children({query, typeaheadResults})}
      </form>
    );
  }
}

Input.propTypes = {
  children: PropTypes.func,
  defaultValue: PropTypes.string,
  placeholder: PropTypes.string,
  size: PropTypes.string,
};

Input.defaultProps = {
  placeholder: 'Search (baselines, users, etc…)',
  size: 'large',
};

export default Input;



// WEBPACK FOOTER //
// ./src/components/search/Input.js